"use client";
import { jsx as _jsx } from "react/jsx-runtime";
// import hooks
import { forwardRef } from "react";
import { useEnvironmentContext } from "../../../components/providers/Environment/index.js";
// import components
import LinkAtom from "@mui/material/Link";
export const LinkAtomComponent = forwardRef((props, ref) => {
    const { components } = useEnvironmentContext();
    const Link = components?.Link ? components.Link : LinkAtom;
    return _jsx(Link, { "data-testid": "Link", ...props, ref: ref });
});
LinkAtomComponent.displayName = "LinkAtomComponent";
export const MuiLinkAtomComponent = LinkAtom;
export default LinkAtomComponent;
